/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AdmissionAdvice from './admission-advice';
import AdmissionAdviceDetail from './admission-advice-detail';
import AdmissionAdviceUpdate from './admission-advice-update';
import AdmissionAdviceDeleteDialog from './admission-advice-delete-dialog';

const AdmissionAdviceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AdmissionAdvice />} />
    <Route path="new" element={<AdmissionAdviceUpdate />} />
    <Route path=":id">
      <Route index element={<AdmissionAdviceDetail />} />
      <Route path="edit" element={<AdmissionAdviceUpdate />} />
      <Route path="delete" element={<AdmissionAdviceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AdmissionAdviceRoutes;
